import React, {Component, useState} from 'react';

import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import Input from "../../components/TextInput"

import {
    Button, DataTable, DataTableSkeleton, FormGroup,
    Modal,
    NumberInput, Pagination,
    RadioButton, RadioButtonGroup,
    Table, TableBody, TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
    TableToolbar,
    TableToolbarContent,
    TableToolbarSearch, TextInput
} from "carbon-components-react";
import {Edit16, Undo16, Warning16} from "@carbon/icons-react";
import Layout from "../Layout";

export default class extends Component {
    state = {
        showModal: false,
        showModalSave: false,
        showModalSaveMessage: false,
        DisableEditPorcent: false,
        DisableText: false,
        submitType: 'Lote',
        porcent: 1,
        selectI: true,
        selectD: false,
        type: 1,
        form: {}
    };

    handleChange = e => {
        e.preventDefault();
        const {name, value} = e.target;
        this.setState(prevState => ({
            DisableEditPorcent: true,
            showModalSaveMessage: false,
            submitType: 'Individual',
            form: {...prevState.form, [name]: value}
        }));
    };

    changeValue() {
        var x = document.getElementById("tj-input").value;
        var fm = 1
        var y = 0;
        var rates = document.getElementsByName('radio-button-group');
        var rate_value;
        for (var i = 0; i < rates.length; i++) {
            if (rates[i].checked) {
                rate_value = rates[i].value;

            }
        }
        this.setState({type: rate_value})
        //alert(this.state.type);
        if (rate_value == 1) {
            y = fm + (x / 100)
        } else {

            y = fm - (x / 100)
        }
        this.setState({porcent: y})
        this.forceUpdate();
    }

    guidGenerator() {
        var S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    }

    getName(name) {
        name = name.replace(":valor", "");
        return name;
    }

    renderInput = (name, type, value = '') => {

        name = name.replace(":valor", "");
        let key = name;
        return <div key={key}>
            <TextInput onInput={(e) => {
                this.handleChange(e)
            }} id={name} name={name} type={type} readOnly={this.state.DisableText}
                       defaultValue={this.state.form[name] * this.state.porcent || value * this.state.porcent}/></div>
    };

    getValueTextBox(row_value, state_value) {
        return Math.round(state_value * this.state.porcent) || Math.round(row_value * this.state.porcent);
    }

    async onSubmitForm() {
        let retorno = this.state.form;
        if (this.state.submitType == 'Lote') {
            retorno = this.state.porcent;
        }

        this.props.onSubmitForm(this.state.submitType, retorno);

        this.setState({
            showModalSave: false,
            showModalSaveMessage: true,
            DisableEditPorcent: false,
            DisableText: false,
            submitType: "Lote",
            porcent: 1,
            form: {}
        });
    }

    onChangePagination(arg1, arg2, arg3) {
        this.props.onChangePagination(arg1.page);
    }


    render() {
        let {rows, headers, isLoading, contadorTotal, descDate, report} = this.props;
        if (!isLoading) {
            console.log('CHILID->', isLoading, rows);
            //  alert('AAAA');
        }

        let desc = contadorTotal + " Itens     ";
        let linhasAfetadas = 0;

        if (typeof this.state.form !== undefined) {

            if (this.state.form && this.state.DisableText == false)
                linhasAfetadas = Object.keys(this.state.form).length;
            else if (typeof contadorTotal !== undefined && this.state.DisableEditPorcent == true) {
                linhasAfetadas = contadorTotal;
            }
        }
        return (
            <div>
                <div>
                    <Modal
                        modalHeading="Group editing - Quantities"
                        open={this.state.showModal}
                        onRequestClose={e => this.setState({showModal: false})}
                        onRequestSubmit={e => this.setState({
                            showModal: false,
                            DisableEditPorcent: true,
                            DisableText: true,
                            showModalSaveMessage: false,
                            submitType: 'Lote'
                        }, this.changeValue())}
                        primaryButtonText="Apply"
                        secondaryButtonText="Cancel"
                        size='xs'
                    >
                        <p>Select action and value to apply to all itens in the report</p>
                        <FormGroup
                            legendText="Radio button heading"
                        >
                            <RadioButtonGroup
                                defaultSelected="default-selected"
                                legend="Group Legend"
                                name="radio-button-group"
                                valueSelected="1"
                                labelPosition='right' orientation='vertical'>
                                <RadioButton
                                    id="radio-1"
                                    labelText="Increase"
                                    name="choose-porcent"
                                    value="1"

                                />
                                <RadioButton
                                    id="radio-2"
                                    labelText="Decrease"
                                    name="choose-porcent"
                                    value="0"

                                />
                            </RadioButtonGroup>
                        </FormGroup>
                        <NumberInput
                            id="tj-input"
                            invalidText="Number is not valid"
                            label="Value (%)"
                            max={1000000}
                            min={0}
                            step={1}
                            value={10}
                        />
                        <br/>
                        <span><strong>Caution</strong></span>
                        <p><span className="icon-warning"><Warning16/></span>This action will
                            affect {contadorTotal} itens.
                        </p>
                    </Modal>
                </div>
                <div>
                    <Modal
                        modalHeading="Editing"
                        open={this.state.showModalSave}
                        onRequestClose={e => this.setState({showModalSave: false})}
                        onRequestSubmit={e => this.onSubmitForm()}
                        primaryButtonText="Save"
                        secondaryButtonText="Cancel"
                        size='xs'
                    >
                        <span><h2
                            className="color-title-h2">This action will affect {linhasAfetadas} itens in the list.</h2></span>

                    </Modal>
                </div>
                {isLoading ? (
                    <div className="bx--col-padding  p-2-rem">
                        <DataTableSkeleton/>
                    </div>
                ) : (
                    <DataTable rows={rows} headers={headers}>
                        {({
                              rows,
                              headers,
                              getHeaderProps,
                              getRowProps,
                              getTableProps,
                          }) => (
                            <TableContainer className="upload-table"
                                            title="Report"
                                            description={desc + " / " + descDate}>
                                <TableToolbar>
                                    <TableToolbarContent>
                                        {!report ? (
                                                <Button
                                                    hasIconOnly
                                                    renderIcon={Edit16}
                                                    tooltipAlignment="center"
                                                    tooltipPosition="top"
                                                    iconDescription="Edit"
                                                    kind='secondary'
                                                    disabled={this.state.DisableEditPorcent}
                                                    onClick={e => this.setState({showModal: true})}
                                                />)
                                            : ('')}
                                        <Button
                                            hasIconOnly
                                            renderIcon={Undo16}
                                            tooltipAlignment="center"
                                            tooltipPosition="top"
                                            iconDescription="Reset"
                                            kind='secondary'
                                            onClick={e => this.setState({
                                                DisableEditPorcent: false,
                                                DisableText: false,
                                                showModalSaveMessage: false,
                                                submitType: 'Lote',
                                                porcent: 1,
                                                form: {}
                                            }, this.forceUpdate())}
                                        />
                                        <Button onClick={e => this.setState({showModalSave: true})}>SAVE</Button>
                                    </TableToolbarContent>

                                </TableToolbar>
                                <Table {...getTableProps()} useZebraStyles>
                                    <TableHead>
                                        <TableRow>
                                            {headers.map((header) => (
                                                <TableHeader
                                                    key={header.key}
                                                    {...getHeaderProps({header})}
                                                >
                                                    {header.header}
                                                </TableHeader>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row, key) => (
                                            <TableRow
                                                key={`tbody_${key}`}
                                                {...getRowProps({row})}
                                            >
                                                {row.cells.map((cell, key2) => (
                                                    <TableCell key={`tbody_${key}_${key2}`}>
                                                        {cell.id.includes('valor') ? (
                                                            /* <React.Fragment>
                                                                 {this.renderInput(cell.id, 'number', cell.value)}
                                                             </React.Fragment>*/
                                                            <React.Fragment>
                                                                <Input small={'large'} type="number"
                                                                       id={this.getName(cell.id)}
                                                                       name={this.getName(cell.id)}
                                                                       placeholder={'0'}
                                                                       min="0" step="1"
                                                                       onChange={this.handleChange}
                                                                       readOnly={this.state.DisableText}
                                                                       value={this.getValueTextBox(cell.value, this.state.form[this.getName(cell.id)])}/>
                                                            </React.Fragment>
                                                            //this.renderInput(cell.id, 'number', cell.value)
                                                        ) : (cell.value)}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <Pagination
                                    className="paginator"
                                    totalItems={contadorTotal}
                                    pageSizes={[20]}
                                    backwardText="Anterior"
                                    forwardText="Next"
                                    PageSize={20}
                                    itemsPerPageText={"Itens por pagina"}
                                    onChange={(arg1, arg2, arg3) => {

                                        this.onChangePagination(arg1, arg2, arg3);
                                    }
                                    }
                                ></Pagination>
                            </TableContainer>
                        )}
                    </DataTable>
                )}
            </div>
        );
    }
}
